import React, { forwardRef, useContext } from 'react';
import { withStyles, Divider } from '@material-ui/core';
import Carousel from '../../carousel/Carousel';
import DataContext from '../../data/DataContext';
import { openLink } from '../../util/utilNative';

const styles = (theme) => ({
  root: {
    position: 'relative',
    letterSpacing: '-0.0313rem',
    margin: '0.375rem 0rem',
    zIndex: 10,
  },
  carousel: {
    width: '100%',
    height: '9rem',
  },
  listitem: {
    padding: '0',
    display: 'flex',
    margin: '0 0 0.375rem 0',
  },
  card: {
    width: '20rem',
    height: '100%',
    flex: 'auto',
    background: '#fff',
    border: '0.0625rem solid #d7d7d7',
    borderRadius: '0.375rem',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    margin: '0 0.375rem 0 0',
    boxShadow: '0 0.125rem 0.375rem 0 rgba(0, 0, 0, 0.1)',
    position: 'relative',
  },
  thumbnail: {
    minHeight: '9.75rem',
    padding: '1rem 0 0 0',
    margin: '1rem 0 0 0',
    // cursor: 'pointer',
    background: 'none',
    border: 'none',
  },
  thumbnailImage: {
    width: 'auto',
    height: '11.25rem',
  },
  info: {
    flexGrow: 1,
    minHeight: '9.688rem',
  },
  infoTitle: {
    display: 'flex',
    justifyContent: 'flex-start',
    fontSize: theme.font.size16, // "15px",
    fontWeight: 'bold',
    color: theme.color.text_color.black,
    textAlign: 'left',
    padding: '0rem 1.25rem',
    minHeight: '2.875rem',
    lineHeight: '1.38',
  },
  infoDescription: {
    display: 'flex',
    justifyContent: 'flex-start',
    fontSize: theme.font.size12,
    fontWeight: 'normal',
    color: theme.color.text_color.grey,
    padding: '0rem 1.25rem',
    // margin: "0 0 12.5px 0"
    // textAlign: "center",
  },
  horizontalDivider: {
    width: 'auto',
    height: '0.0625rem',
    backgroundColor: theme.color.divider.grey,
    margin: '0.7188rem 1.25rem',
  },
  baseInfo: {
    margin: '0 1.25rem',
    display: 'flex',
    flexDirection: 'column',
    minHeight: '2.313rem',
  },
  baseInfoDesc: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  name: {
    fontSize: theme.font.size12,
    color: '#000',
  },
  greyName: {
    color: '#aaa',
    textDecoration: 'line-through',
  },
  baseInfoname: {
    color: '#666',
  },
  productPriceInfo: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    margin: '0 1.25rem',
  },
  price: {
    color: '#000',
    fontSize: theme.font.size16,
    fontWeight: '700',
  },
  productPrice: {
    fontSize: theme.font.size12,
  },

  buttonContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0.75rem 1.25rem 1.25rem',
  },
  buttons: {
    height: '2.5rem',
    width: '100%',
  },
  btnSubs: {
    borderRadius: '0.375rem',
    backgroundColor: '#EA1917',
    color: '#fff',
    textAlign: 'center',
    width: '100%',
    height: '100%',
    fontSize: theme.font.size14,
    fontWeight: '700',
    lineHeight: '2.5rem',
    border: 'none',
    cursor: 'pointer',
  },
  btnDisabled: {
    backgroundColor: '#666',
  },
  discountRate: {
    color: '#EA1917',
  },
});

const SubsCard = forwardRef((props, ref) => {
  const { classes, data } = props;
  const context = useContext(DataContext);
  const isMobile = context.userAgent.deviceType === 'mobile';

  let cardList = data.items.map((item, key) => {
    const productImgUrl = isMobile
        ? item.link.product_image_mobile_url
        : item.link.product_image_url,
      productTitle = item.link.product_title,
      productName = item.link.product_name,
      productLinkUrl = item?.link?.product_link_url,
      productLinkType = item?.link?.type || 'external'; // 'external'

    const handleOpenLink = (type, url) => {
      if (url) {
        openLink(context, type, url);
      }
    };

    const productStatus = item?.product_status; // '판매'
    const productMasterPrice = item?.product_price?.product_master_price, // '11,900'
      productObsPrice = item?.product_price?.product_obs_price, // '11,900'
      discountRate = item?.product_price?.discount_rate, // '0%'
      promotionYn = item?.product_price?.promotion_yn, // 'N' | 'Y'
      benefitsArr = item?.product_price?.benefits || [];

    const baseInfoArr = item?.base_info || [];

    const buttonsArr = item?.buttons || [];

    return (
      <div key={`cardList${key}`} className={classes.listitem}>
        <div className={classes.card}>
          <button
            className={classes.thumbnail}
            onClick={() => handleOpenLink(productLinkType, productLinkUrl)}
          >
            <img
              className={classes.thumbnailImage}
              src={productImgUrl}
              alt={`${productName} 상세 바로가기`}
            />
            {/* HTML TAG가 들어간 경우 처리 */}
            <div
              className={classes.infoTitle}
              dangerouslySetInnerHTML={{ __html: productTitle }}
              role={'text'}
            />
            <div
              className={classes.infoDescription}
              dangerouslySetInnerHTML={{ __html: productName }}
              role={'text'}
            />
          </button>
          <div className={classes.info}>
            <Divider
              orientation={'horizontal'}
              className={classes.horizontalDivider}
              component={'div'}
              disabled
            />

            <div className={classes.baseInfo}>
              {baseInfoArr.map((it, idx) => {
                const valueName = it.ValueName, // '회수관리', 12개월
                  baseInfoname = it.Name; // 서비스 유형, 서비스 주기'
                return (
                  <div key={`baseInfo${idx}`} className={classes.baseInfoDesc}>
                    <div className={`${classes.name} ${classes.baseInfoname}`}>
                      {baseInfoname}
                    </div>
                    <div className={classes.name}>{valueName}</div>
                  </div>
                );
              })}
            </div>

            {/* <Divider
              orientation={'horizontal'}
              className={classes.horizontalDivider}
              component={'div'}
              disabled
            />

            <div className={classes.baseInfo}>
              <div className={classes.baseInfoDesc}>
                <div className={`${classes.name} ${classes.baseInfoname}`}>
                  상품 판매가
                </div>
                <div
                  className={`${classes.name} ${productObsPrice && classes.greyName}`}
                >{`월 ${productMasterPrice}원`}</div>
              </div>

              {productObsPrice && (
                <div className={classes.baseInfoDesc}>
                  <div className={`${classes.name} ${classes.baseInfoname}`}>
                    상품 혜택가
                  </div>
                  <div className={classes.name}>
                    <span className={classes.discountRate}>{discountRate}</span>
                    {` 월 ${productObsPrice}원`}
                  </div>
                </div>
              )}
            </div> */}

            <Divider
              orientation={'horizontal'}
              className={classes.horizontalDivider}
              component={'div'}
              disabled
            />

            <div className={classes.productPriceInfo}>
              <div className={`${classes.price} ${classes.productPrice}`}>
                1회차 월 요금
              </div>
              <div className={classes.price}>{`월 ${
                (productObsPrice && productObsPrice) || productMasterPrice
              }원 ~`}</div>
            </div>

            <div className={classes.buttonContainer}>
              {buttonsArr.map((it, idx) => {
                const label = it.label,
                  type = it.type,
                  parametersAction = it.parameters.action,
                  parametersEnable = it.parameters.enable,
                  parametersUrl = isMobile ? it.parameters.mobile_url : it.parameters.url;

                return (
                  <div key={`buttons${idx}`} className={classes.buttons}>
                    <button
                      className={`${classes.btnSubs} ${
                        !parametersEnable && classes.btnDisabled
                      }`}
                      onClick={() => handleOpenLink(type, parametersUrl)}
                    >
                      {label}
                    </button>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    );
  });

  return cardList;
});

function SubscriptionCard(props) {
  const { classes, data } = props;
  const context = useContext(DataContext);

  console.log('====== 테스트 data ======', data);

  return (
    <div className={classes.root}>
      <Carousel
        className={classes.carousel}
        component={withStyles(styles)(SubsCard)}
        data={data}
        ariaLabel={context.string.aria.product}
      />
    </div>
  );
}
export default withStyles(styles)(SubscriptionCard);
